export function isPathAccessible(
    pathname: string,
    accessPaths: string[]
  ): boolean {
    return accessPaths.some((accessPath) => {
      const regex = new RegExp(
        "^" + accessPath.replace(/:[^\s/]+/g, "([\\w-]+)") + "$"
      );
      return regex.test(pathname);
    });
  }
  